import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import 'styleLess/signature/taskinboxSN.scss'
import { getCookie } from 'helper/cookie'
import { Empty } from 'antd'
import { Form, Select, Button, Dropdown, Menu, notification } from 'antd'
import { InboxOutlined, MailOutlined, PlusOutlined } from '@ant-design/icons'
import Emytystate from 'icons/createproject/supportneed.svg'
import more from 'icons/More.svg'
import {
  getResultOptionSupportNeed,
  updateStatusSupportNeed,
  sendMailSupportNeed,
} from 'api/Project/supportneed'
import ModalAddSupportNeed from 'common/SupportNeed/ModalAdd'
import ModalDeleteSupportNeed from 'common/SupportNeed/ModalDelete'
import { CounterContext } from 'redux/Golbalvalues'
const Container = styled.div`
  // background-color: #af2;
`

const initalState = {
  data: [],
  isLoading: true,
}

const SupportNeedTask = (props) => {
  const {
    projectId,
    subtaskId,
    authorityId,
    hidden,
    getLogList,
    getSupportNeed,
    dataSupportNeed,
  } = props
  const { mainRoleUser, adminPermission } = useContext(CounterContext)
  const [viewNameBtn, setViewNameBtn] = useState('')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [viewDisplayOk, setViewDisplayOk] = useState('')
  const [viewDisable, setViewDisable] = useState(false)
  const [modalState, setModalState] = useState(false)
  const [searchTerm, setsearchTerm] = useState(0)
  const [form] = Form.useForm()
  const token = getCookie('access_token_admin')
  const companyIDUser = getCookie('companyId_project')
  const [dataOption, setDataOption] = useState(initalState.data)
  const [typeBtn, setTypeBtn] = useState()
  const [dataEdit, setDataEdit] = useState(initalState.data)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [usefunction, setUsefunction] = useState(false)
  const [usecasestatus, setUseCaseStatus] = useState(false)
  const [mockStatusType, setmockStatusType] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      id: 2,
      status_name: 'In Progress',
      key: 'inprogress',
    },
    {
      id: 3,
      status_name: 'Done',
      key: 'done',
    },
    {
      id: 4,
      status_name: 'Cancel',
      key: 'cancel',
    },
  ])
  const [mockStatusType2, setmockStatusType2] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      id: 2,
      status_name: 'Cancel',
      key: 'cancel',
    },
  ])

  ////// ^^^^^^^^^^^^^^^^^^^^^^^^^^^^ Disabled permission zone ^^^^^^^^^^^^^^^^^^^^///////
  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  useEffect(() => {
    if (mainRoleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 5 || item.menu_id == 4) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  const QueryAuthority = () => {
    // ถ้า hidden === true จะแก้ไขไม่ได้
    // ถ้า hidden === false จะแก้ไขได้
    if (hidden === true) {
      setUsefunction(false) // not use
      setUseCaseStatus(false)
    } else if (hidden === false && [1, 2, 3].includes(authorityId)) {
      setUsefunction(true) //ready to use
      setUseCaseStatus(true)
    } else if (hidden === false && ![1, 2, 3].includes(authorityId)) {
      setUsefunction(true)
      setUseCaseStatus(false)
    }

    // check status
  }
  useEffect(() => {
    QueryAuthority()
  }, [hidden])

  ////// ^^^^^^^^^^^^^^^^^^^^^^^^^^^^ Disabled permission zone ^^^^^^^^^^^^^^^^^^^^///////
  const onChangeSearch = (value) => {
    // console.log(value)
    setsearchTerm(value)
  }
  const Editremark = (value) => {
    setViewDisable(false)
    setViewDisplayOk('')
    setViewNameBtn('')
    setTypeBtn('edit')
    setModalState(true)
    setDataEdit(value)
  }
  const getOption = async () => {
    getResultOptionSupportNeed({
      company_id: parseInt(companyIDUser),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOption([])
          return true
        }
        if (status === 200) {
          setDataOption(data)
        } else {
          setDataOption([])
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getSupportNeed()
      getOption()
      QueryAuthority()
    }
  }, [token])

  const openNotificationWithIcon = (type, data, value) => {
    if (value == 'Done') {
      notification[type]({
        message: 'Success',
        description: 'You have been ' + value.toLowerCase() + '.',
        duration: 3,
      })
    } else {
      notification[type]({
        message: 'Success',
        description: 'You have been ' + value.toLowerCase() + 'ed.',
        duration: 3,
      })
    }
  }
  const renderDropdown = (item) => {
    if (usefunction === true) {
      return (
        <Dropdown overlay={(e) => menu(item)} trigger={['click']} placement="bottomRight">
          <a>
            <img hidden={hidden} src={more} />
          </a>
        </Dropdown>
      )
    } else {
      return <></>
    }
  }
  const menu = (item) => {
    if (item.sendmail_status == 'Y') {
      return (
        <Menu>
          <Menu.Item key="0" onClick={() => View(item)}>
            View
          </Menu.Item>
        </Menu>
      )
    } else {
      return (
        <Menu>
          <Menu.Item key="0" onClick={() => Editremark(item)}>
            Edit
          </Menu.Item>

          <Menu.Item key="1" onClick={() => Deleteremark(item)}>
            Delete
          </Menu.Item>
        </Menu>
      )
    }
  }

  const View = (data) => {
    setModalState(true)
    setViewDisable(true)
    setViewDisplayOk('none')
    setViewNameBtn('Close')
    setDataEdit(data)
    setTypeBtn('edit')
  }
  const foundType = (item) => {
    return dataOption.map((inner) => {
      if (inner.id == item) {
        return inner.title_en
      }
    })
  }

  const showModalStateAdd = () => {
    setViewDisable(false)
    setViewDisplayOk('')
    setViewNameBtn('')
    setTypeBtn('add')
    setModalState(true)
  }

  let arrr = []
  const playState = () => {
    if (dataSupportNeed.length == 0) {
      return (
        <div className="EmptyStateContainer">
          <img className="big-icons" src={Emytystate}></img>
          <h2>Please add Support need in your project (optional)</h2>
          <Button
            id="btn_addSup"
            className="BTN_Next"
            onClick={() => showModalStateAdd()}
            hidden={hidden}
            style={{width: 'fit-content'}}
          >
            <PlusOutlined className="Icon-color" /> Add New Support Need
          </Button>
        </div>
      )
    } else {
      return (
        <div className="task-supportneed-component-container">
          <div className="support-header">
            <Select
              className="Select Select-Custom style-responsive-select"
              placeholder="All "
              style={{ minWidth: '297px', borderRadius: '4px' }}
              size="large"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSearch(e)}
            >
              <Option value={0}>All</Option>
              {mockStatusType.map((item) => (
                <Option value={item.status_name}>{item.status_name}</Option>
              ))}
            </Select>
            <Button
              id="btn_addSup"
              className="BTN_ClassA"
              onClick={() => showModalStateAdd()}
              hidden={hidden}
            >
              <PlusOutlined className="Icon-color" />
              Add New
            </Button>
          </div>

          <div className="support-body">
            {dataSupportNeed &&
              dataSupportNeed.filter((item) => {
                if (searchTerm === 0 || searchTerm === undefined) {
                  arrr.push(item)
                } else if (searchTerm === item.support_status) {
                  arrr.push(item)
                }
              })}
            {showMap(arrr)}
          </div>
        </div>
      )
    }
    // }
  }
  const showMap = (data_supportneed) => {
    if (data_supportneed == [] || data_supportneed == Empty || data_supportneed == '') {
      return (
        <div className="EmptyStateContainer">
          <InboxOutlined className="InboxOutlined big-icons" />
          <h2>No Data</h2>
        </div>
      )
    } else {
      return (
        <div className="grid-item-container">
          {data_supportneed.map((item, index) => {
            return (
              <div className="box-item-container">
                <div className="left">
                  <div className="remark">
                    <span className="small ">Remark</span>
                    <div style={{ display: 'grid' }}>
                      <p className="cutter-text-line-1"> {item.description}</p>
                    </div>
                  </div>
                  <div className="type">
                    <span className="small ">Type</span>

                    <p style={{ minHeight: 18 }}>{foundType(item.support_type_id)}</p>
                  </div>
                  <div className="initial-container">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span className="small">Status</span>
                      {foundStatus(item)}
                    </div>
                    {ButtonSiteEliter(item)}
                  </div>
                </div>
                <div className="right">{renderDropdown(item)}</div>
              </div>
            )
          })}
        </div>
      )
    }
  }
  const foundStatus = (item) => {
    if (permissionPage.update === false) {
      return <p style={{ marginTop: 4, marginBottom: 4 }}>{item.support_status}</p>
    } else {
      if (item.support_status === 'Done') {
        return <p style={{ marginTop: 4, marginBottom: 4 }}>Done</p>
      } else {
        if (usecasestatus === true) {
          return (
            <Select
              className="selectionassignee"
              placeholder="dropdown"
              style={{ width: 110 }}
              onChange={(e) => onChange(e, item)}
              value={item.support_status}
            >
              {mockStatusType.map((h) => (
                <Option value={h.status_name}>{h.status_name}</Option>
              ))}
            </Select>
          )
        } else {
          return (
            <Select
              className="selectionassignee"
              placeholder="dropdown"
              style={{ width: 110 }}
              onChange={(e) => onChange(e, item)}
              value={item.support_status}
            >
              {mockStatusType2.map((h) => (
                <Option value={h.status_name}>{h.status_name}</Option>
              ))}
            </Select>
          )
        }
      }
    }
  }

  const onChange = (value, data) => {
    const dataArray = {
      project_id: parseInt(projectId),
      sprintflow_id: parseInt(subtaskId),
      support_status: value,
    }
    try {
      updateStatusSupportNeed({
        supportneed_id: data.id,
        params: dataArray,
        token: token,
      }).then((res) => {
        console.log(res)
        if (res.status === 200) {
          getSupportNeed()
          form.setFieldsValue({
            type: null,
            remark: null,
          })
          openNotificationWithIcon('success', data, value)
          getLogList()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const ButtonSiteEliter = (data) => {
    if (hidden === true) {
      data.enable_button = 'N'
    }
    if (data.enable_button == 'Y') {
      return (
        <Button
          id="btn_sendMail"
          className="BTN_Previous"
          disabled={false}
          onClick={() => onClickSendMail(data)}
          hidden={hidden}
        >
          <MailOutlined className="Icon-color" /> Send Mail
        </Button>
      )
    } else {
      return (
        <Button
          id="btn_sendMail"
          className="BTN_Previous"
          disabled={true}
          hidden={hidden}
        >
          <MailOutlined className="Icon-color" /> Send Mail
        </Button>
      )
    }
  }
  const onClickSendMail = (data) => {
    try {
      sendMailSupportNeed({
        supportneed_id: data.id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getLogList()
          getSupportNeed()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const Deleteremark = (value) => {
    setDataEdit(value)
    setVisibleDelete(true)
  }

  return (
    <Container>
      {playState()}

      <ModalAddSupportNeed
        setModalState={setModalState}
        modalState={modalState}
        viewNameBtn={viewNameBtn}
        viewDisplayOk={viewDisplayOk}
        viewDisable={viewDisable}
        dataEdit={dataEdit}
        typeBtn={typeBtn}
        idEditPRJ={projectId}
        idSprintflow={subtaskId}
        getSupportNeed={getSupportNeed}
        stateKPI={parseInt(subtaskId)}
        pageTaskInboxDetail={'taskinboxdetail'}
        getLogList={getLogList}
      />
      <ModalDeleteSupportNeed
        idEditPRJ={projectId}
        setVisibleDelete={setVisibleDelete}
        visibleDelete={visibleDelete}
        dataEdit={dataEdit}
        getSupportNeed={getSupportNeed}
        pageTaskInboxDetail={'taskinboxdetail'}
        getLogList={getLogList}
      />
    </Container>
  )
}

export default SupportNeedTask
